module.exports = __webpack_public_path__ + "media/bgm_109.04ca2d13.m4a";